import {
  BaseEvent,
  isIdea,
  isInformation,
  isQuality,
  isEnvironment,
  isHealthAndSafety
} from '@domain/shifthandover'
import {
  StatusWithNoneAndCancellationAndApproverAndWorkOrderStates,
  eventStatusListWorkOrder,
  WorkOrderEventStatus
} from '@hconnect/common/types'

export function isWorkOrderStatus(
  status: StatusWithNoneAndCancellationAndApproverAndWorkOrderStates
) {
  return eventStatusListWorkOrder.includes(status as WorkOrderEventStatus)
}

export const isEventWithStatusNone = (event: BaseEvent): boolean => {
  return (
    isInformation(event) ||
    isIdea(event) ||
    isQuality(event) ||
    isEnvironment(event) ||
    isHealthAndSafety(event)
  )
}
